// SnapTransfer extension — not in the reference library.
// Tiny footer credit rendered on public pages (download + file request).
// `inverse` swaps link color for dark-bg pages.
interface PoweredByFooterProps {
  inverse?: boolean
  marginTop?: number
}

export function PoweredByFooter({ inverse = false, marginTop }: PoweredByFooterProps) {
  return (
    <footer
      style={{
        marginTop,
        padding: marginTop ? 0 : '28px 36px',
        textAlign: 'center',
        fontFamily: 'var(--font-mono)',
        fontSize: 11,
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        opacity: inverse ? 0.55 : 0.6
      }}>
      Powered by{' '}
      <a
        href="https://snaptransfer.app"
        style={{
          color: inverse ? 'var(--paper)' : 'var(--ink)',
          textDecoration: 'underline',
          fontWeight: 700
        }}>
        SnapTransfer
      </a>
    </footer>
  )
}
